module.exports = __webpack_public_path__ + "img/iso.8b2eb92d.png";